import { Box, Button, CircularProgress, Grid } from "@mui/material";
import FileInput from "components/FileInput";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { useFetcher } from "react-router-dom";
import Alert from "@mui/material/Alert";
import HLROperationList from "./HLROperations";



function CheckNumberHLR() {
    const fetcher = useFetcher();
    const inputDisabled = fetcher.state === "submitting";


    return (
        <>
            <Grid
                item
                xs={12}
                component={fetcher.Form}
                method="post"
                encType="multipart/form-data">
                <Grid container spacing={2}>
                    {fetcher.data === true && (
                        <Grid item xs={12}>
                            <Alert severity="success">File uploaded successfully !</Alert>
                        </Grid>
                    )}
                    {fetcher.state === "idle" && fetcher.data && fetcher.data.error && (
                        <Grid item xs={12}>
                            <Alert severity="error">{fetcher.data.error}</Alert>
                        </Grid>
                    )}
                    <Grid item xs={12} md={8}>
                        <FileInput
                            name="file"
                            required
                            label="Choose a csv file "
                            disabled={inputDisabled}
                            size="small"
                            inputProps={{ accept: "text/csv" }}
                        />
                    </Grid>

                    <Grid item xs={12} md={4} display="flex" alignItems="center">
                        <Button
                            fullWidth
                            type="submit"
                            variant="contained"
                            endIcon={!inputDisabled && <FileUploadIcon />}
                            disabled={inputDisabled}>
                            <Box
                                sx={{
                                    height: 24,
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}>
                                {inputDisabled ? (
                                    <CircularProgress size={16} />
                                ) : (
                                    "Upload contacts"
                                )}
                            </Box>
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
            <HLROperationList />
        </>
    );
}

export default CheckNumberHLR;
